export default ({ request }) => ({
  sampleInfoListApi(data = {}) {
    return request({
      url: '/master/sample/info/list',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sampleInfoChooseListApi(data = {}) {
    return request({
      url: '/master/sample/info/choose/list',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sampleInfoSubProductListApi(data = {}) {
    return request({
      url: '/master/sample/info/subProductList',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sampleInfoDetailApi(data = {}) {
    return request({
      url: '/master/sample/info/detail',
      method: 'post',
      data,
    })
  },
  sampleInfoSubProductSaveApi(data = {}) {
    return request({
      url: '/master/sample/info/subProductSave',
      method: 'post',
      data,
    })
  },
  sampleInfoSaveApi(data = {}) {
    return request({
      url: '/master/sample/info/save',
      method: 'post',
      data,
    })
  },
  sampleInfoDelApi(data = {}) {
    return request({
      url: '/master/sample/info/del',
      method: 'post',
      data,
    })
  },
  sampleInfoReductionApi(data = {}) {
    return request({
      url: '/master/sample/info/reduction',
      method: 'post',
      data,
    })
  },
  sampleInfoCopyApi(data = {}) {
    return request({
      url: '/master/sample/info/copy',
      method: 'post',
      data,
    })
  },
  sampleInfoAuditApi(data = {}) {
    return request({
      url: '/master/sample/info/audit',
      method: 'post',
      data,
    })
  },
  sampleInfoRejectApi(data = {}) {
    return request({
      url: '/master/sample/info/reject',
      method: 'post',
      data,
    })
  },
  setsampleInfoDefaultImageApi(data = {}) {
    return request({
      url: '/master/sample/info/image/defaultImage',
      method: 'post',
      data,
    })
  },
  sampleInfoImageListApi(data = {}) {
    return request({
      url: '/master/sample/info/image/list',
      method: 'post',
      data,
    })
  },
  sampleInfoImageDelApi(data = {}) {
    return request({
      url: '/master/sample/info/image/del',
      method: 'post',
      data,
    })
  },
  sampleInfoImageBatchUploadApi(data = {}) {
    return request({
      url: '/master/sample/info/image/batch/upload',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  sampleInfoImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/master/sample/info/image/update/sortOrder',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialListApi(data = {}) {
    return request({
      url: '/master/sample/info/material/list',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialDetailApi(data = {}) {
    return request({
      url: '/master/sample/info/material/detail',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialSaveApi(data = {}) {
    return request({
      url: '/master/sample/info/material/save',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialDelApi(data = {}) {
    return request({
      url: '/master/sample/info/material/del',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialUpdateSortApi(data = {}) {
    return request({
      url: '/master/sample/info/material/updateSort',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialUpdateCostPriceApi(data = {}) {
    return request({
      url: '/master/sample/info/material/update/costPrice',
      method: 'post',
      data,
    })
  },
  sampleInfoMaterialUpdateFabricApi(data = {}) {
    return request({
      url: '/master/sample/info/material/updateFabric',
      method: 'post',
      data,
    })
  },
  sampleInfoSelectQtyUnitApi(data = {}) {
    return request({
      url: '/master/common/dict/biz',
      method: 'post',
      data,
    })
  },
  sampleInfoLinkDataListApi(data = {}) {
    return request({
      url: '/master/sample/info/linkData/list',
      method: 'post',
      data,
    })
  },
  masterFabricListApi(data = {}) {
    return request({
      url: '/master/fabric/list',
      method: 'post',
      data,
    })
  },
  masterFabricAttributesSelectApi(data = {}) {
    return request({
      url: '/master/fabric/attributes/attributesSelect',
      method: 'post',
      data,
    })
  },
  sampleInfoAuditListApi(data = {}) {
    return request({
      url: '/master/sample/info/auditList',
      method: 'post',
      data,
    })
  },
  sampleInfoUpdateSalePersonApi(data = {}) {
    return request({
      url: '/master/sample/info/updateSalePerson',
      method: 'post',
      data,
    })
  },
  sampleInfoUpdateDesignerApi(data = {}) {
    return request({
      url: '/master/sample/info/updateDesigner',
      method: 'post',
      data,
    })
  },
  sampleInfoRemoveApi(data = {}) {
    return request({
      url: '/master/sample/info/remove',
      method: 'post',
      data,
    })
  },
  sampleInfoBindApi(data = {}) {
    return request({
      url: '/master/sample/info/bind',
      method: 'post',
      data,
    })
  },
  masterAttributeDictionary_list(data = {}) {
    return request({
      url: '/digitalCenter/masterAttributeDictionary/list',
      method: 'post',
      data,
    })
  },
})
